import * as yup from 'yup'

const isDirectoryInvalid = (value: string) => /[^A-Za-z0-9.*_ -]/.test(value)

const commonSchema = (currentUserId: number) => ({
  directory: yup
    .string()
    .required('Please select a folder that contains your dataset data.')
    .test('isDirectoryInvalid', function (directory) {
      const { path, createError } = this

      if (directory && isDirectoryInvalid(directory)) {
        return createError({
          path,
          message: `There are invalid characters in the folder name.
          Only numbers, letters a-z, spaces, "-", "_", "*", "." are supported. Please change the folder name.`,
        })
      }

      return true
    }),
  projectName: yup.string().required('Project name is a required field.'),
  projectDescription: yup
    .string()
    .required('Project description is a required field and must be more than or equal to 100 characters.')
    .min(100, 'Project description must be more than or equal to 100 characters.'),
  name: yup.string().required('Dataset name is a required field.'),
  description: yup
    .string()
    .required('Dataset description is a required field and must be more than or equal to 500 characters.')
    .min(500, 'Dataset description must be more than or equal to 500 characters.'),
  fieldOfResearchCodes: yup.array().min(1, 'You must select at least one Field of research codes.'),
  dataTypes: yup.array().of(
    yup.object().shape({
      name: yup
        .string()
        .required('Data type name is required.')
        .test('noCommas', 'Data type must not contain any comma.', (value) => !value || !value.includes(',')),
    }),
  ),
  linkedPids: yup
    .array()
    .of(
      yup.object().shape({
        label: yup.string().required(),
        value: yup.string().required(),
      }),
    )
    .required(),
  optionalInformation: yup.string(),
  datasetCreators: yup
    .array()
    .min(1, 'You must select at least one user.')
    .test('creator-exists', 'Dataset creator must be in the list.', function (value) {
      if (!value) return false
      const typedValue = value as { userId: number }[]
      return typedValue.some((obj) => obj.userId === currentUserId)
    }),
  accessType: yup.string().required('An access condition is required.'),
  datasetLicenseId: yup
    .number()
    .required('A license and term of access is required')
    .min(1, 'A license type is required.'),
  recordServiceId: yup.number().required(''),
})

const webSchema = {
  checkboxGroup: yup
    .array()
    .of(yup.boolean())
    .test('allConditions', 'All checkboxes must be checked.', (conditions) => {
      const checkForFalsy = conditions === undefined || conditions.some((condition) => condition === false)

      if (checkForFalsy) {
        return false
      }

      return true
    }),
}

export const commonPublishDatasetFormValidationSchema = (currentUserId: number) => {
  return yup.object().shape(commonSchema(currentUserId))
}

export const webPublishDatasetFormValidationSchema = (currentUserId: number) => {
  return yup.object().shape({ ...commonSchema(currentUserId), ...webSchema })
}
